import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import HistoricoSituacaoStore from '@/components/HistoricoSituacao/Store/HistoricoSituacaoStore'
import { displayColorBySituation } from '@/utils/common'
import { Historico, SituacaoEnum } from '@/types/_'
import moment from 'moment'
import modalHistoricoSituacaoModule from './modal-historico-situacao.module'

@Component({
  ...modalHistoricoSituacaoModule,
})
export default class ComponentModalHistoricoSituacao extends Vue {
  activeTab = 'tab-0'

  close() {
    this.getShowModalHistorico = false
  }

  get history() {
    return this.getHistoricoSituacaoStore.historicoSituacao
  }

  get getHistoricoSituacaoStore() {
    return getModule(HistoricoSituacaoStore, this.$store)
  }

  get getShowModalHistorico() {
    return this.getHistoricoSituacaoStore.modal.historicoSituacao
  }

  set getShowModalHistorico(value: boolean) {
    this.getHistoricoSituacaoStore.clearhistoricoSituacao()
    this.getHistoricoSituacaoStore.setShowModalHistoricoSituacao(value)
  }

  formatData(date: Date | string) {
    return moment(date).format('DD/MM/YYYY HH:mm')
  }

  formatTexto(event: Historico) {
    if (event.tipoLog === 'Situacao') {
      switch (event.situacao.key) {
        case SituacaoEnum.Divergente:
          return `Validado e definido por ${event.createdByNome}`

        case SituacaoEnum.ValidacaoPendente:
          return `NF enviada por ${event.createdByNome}`

        case SituacaoEnum.Paga:
          return `Finalizado por ${event.createdByNome}`

        case SituacaoEnum.EnviadoParaPagamento:
          return `Agrupamento gerado por ${event.createdByNome}`

        case SituacaoEnum.Pendente:
          return `Processo iniciado / limpo por ${event.createdByNome}`

        default:
          return `Por ${event.createdByNome}`
      }
    } else {
      switch (event.sucesso) {
        case false:
          return `Notificação não enviada ${event.mensagemLog}`

        default:
          return `Notificação enviada por ${event.createdByNome} para ${event.destinatarios}`
      }
    }
  }

  displayCorSituacao(value: any) {
    return displayColorBySituation(value.tipoLog === 'Situacao' ? value.situacao.key : value.tipoNotificacao.key)
  }
}
